module.exports = __webpack_public_path__ + "static/media/template-expense.dde16afe7f2e276143e07db0cbaabefa.png";